module.exports = __webpack_public_path__ + "img/95.7e1b279c.jpg";